package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError

/**
 * Validator for lockpicking challenge configuration.
 */
object LockpickingValidator {

    const val MIN_LOCK_COUNT = 2
    const val MAX_LOCK_COUNT = 8
    const val MIN_TIME_LIMIT_SECONDS = 30
    const val MAX_TIME_LIMIT_SECONDS = 300

    fun validateLockCount(lockCount: Int): Result<Unit> {
        if (lockCount !in MIN_LOCK_COUNT..MAX_LOCK_COUNT) {
            return Result.failure(
                ValidationError("Lock count must be between $MIN_LOCK_COUNT and $MAX_LOCK_COUNT")
            )
        }
        return Result.success(Unit)
    }

    fun validateTimeLimit(timeLimitSeconds: Int?): Result<Unit> {
        if (timeLimitSeconds != null) {
            if (timeLimitSeconds !in MIN_TIME_LIMIT_SECONDS..MAX_TIME_LIMIT_SECONDS) {
                return Result.failure(
                    ValidationError(
                        "Time limit must be between ${MIN_TIME_LIMIT_SECONDS}s and ${MAX_TIME_LIMIT_SECONDS}s"
                    )
                )
            }
        }
        return Result.success(Unit)
    }

    fun validateTargetParticipant(targetParticipantId: String): Result<Unit> {
        if (targetParticipantId.isBlank()) {
            return Result.failure(ValidationError("A target player must be selected"))
        }
        return Result.success(Unit)
    }

    fun validateForCreation(
        targetParticipantId: String,
        lockCount: Int,
        timeLimitSeconds: Int?
    ): Result<Unit> {
        validateTargetParticipant(targetParticipantId).onFailure { return Result.failure(it) }
        validateLockCount(lockCount).onFailure { return Result.failure(it) }
        validateTimeLimit(timeLimitSeconds).onFailure { return Result.failure(it) }
        return Result.success(Unit)
    }
}
